/* prettier-ignore */

const data = {
  common: {
    title: "Piggy Valut",
    description: "Piggy Valut 管理システム",
    buttons: {
      search: "検索",
      login: "ログイン",
      register: "登録",
      approve: "承認",
      reject: "拒否",
      refresh: "更新",
      viewDetails: "詳細を見る",
      back: "戻る",
      save: "保存",
      saving: "保存中...",
      cancel: "キャンセル",
      confirm: "確認",
      delete: "削除",
      deleting: "削除中...",
      hide: "非表示",
      show: "表示",
      close: "閉じる",
    },
    placeholders: {
      search: "検索...",
    },
    messages: {
      success: "成功",
      updateSuccess: "ユーザー情報を更新しました",
      loginSuccess: "ログイン成功",
      logoutSuccess: "ログアウト成功",
      registerSuccess: "登録成功",
      criticalError: "致命的なエラーが発生しました",
      forbidden: "禁止されたリクエストです",
      notAuthorized: "許可されていないユーザーです",
      noData: "データがありません",
      tooManyRequests: "少し待ってから再試行してください。同じリクエストを非常に速く送信しています。",
      blocked: "ブロックされたユーザーです",
      pending: "承認待ちのユーザーです",
      ipBlocked: "IPがブロックされました",
      serverError: "サーバーエラーが発生しました",
      invalidInput: "入力が無効です",
      invalidCredentials: "ユーザー名またはパスワードが正しくありません",
      invalidReferrer: "紹介者が存在しません",
      referrerRequired: "紹介者は必須です",
      ipBlockedFailed: "IPブロックに失敗しました",
      notAllowedPartner: "許可されていないパートナーです",
      invalidPassword: "パスワードの検証に失敗しました",
      databaseError: "データベースエラーが発生しました",
      usernameInUse: "ユーザー名が既に使用されています",
      createUserError: "ユーザーの作成に失敗しました",
      failedFetch: "データの取得に失敗しました",
      failedFetchUser: "ユーザーの取得に失敗しました",
      failedFetchPendingUsers: "承認待ちユーザーの取得に失敗しました",
      failedFetchOnlineUsers: "オンラインユーザーの取得に失敗しました",
      failedFetchUserTree: "ユーザーの組織図の取得に失敗しました",
      failedFetchUsers: "ユーザーの取得に失敗しました",
      failedFetchUserUpline: "ユーザーの上位ユーザーの取得に失敗しました",
      failedFetchUserDownline: "ユーザーの下位ユーザーの取得に失敗しました",
      failedUpdate: "データの更新に失敗しました",
      failedUpdateUser: "ユーザーの更新に失敗しました",
      failedSave: "データの保存に失敗しました",
      vendorError: "ベンダーエラーが発生しました",
      confirmDelete: "本当に削除しますか？",
      deleteSuccess: "ユーザーが削除されました",
      tokenRefreshed: "トークンが更新されました",
      tokenRefreshFailed: "トークンの更新に失敗しました",
      invalidIpAddress: "IPアドレスが無効です",
      invalidChipTransactionReason: "チャージ取引の理由が無効です",
      captchaExpired: "セキュリティ質問の回答が期限切れです",
      captchaInvalid: "セキュリティ質問の回答が無効です",
      insufficientChip: "チャージが不足しています",
      insufficientPoint: "ポイントが不足しています",
      failedCollectChips: "チャージの収集に失敗しました",
      failedGiveChips: "チャージの付与に失敗しました",
      failedPointsToChips: "ポイントからチャージへの変換に失敗しました",
      notFoundHeadquarter: "本社が見つかりません",
      notFoundUser: "ユーザーが見つかりません",
      failedFetchAdmin: "管理者の取得に失敗しました",
      failedFetchHeadquarter: "本社の取得に失敗しました",
      adminNotAllowed: "管理者はアクセスできません",
      partnerNotAllowed: "パートナーはアクセスできません",
      userNotAllowed: "ユーザーはアクセスできません",
      failedFetchTotalInquiries: "問い合わせの総数の取得に失敗しました",
      failedFetchInquiries: "問い合わせリストの取得に失敗しました",
      failedCreateInquiry: "問い合わせの作成に失敗しました",
      failedUpdateInquiry: "問い合わせの更新に失敗しました",
      failedFetchInquiry: "問い合わせの取得に失敗しました",
      failedFetchTotalNotices: "お知らせの総数の取得に失敗しました",
      failedFetchNotices: "お知らせリストの取得に失敗しました",
      failedCreateNotice: "お知らせの作成に失敗しました",
      failedUpdateNotice: "お知らせの更新に失敗しました",
      failedIncrementNoticeViewCount: "お知らせの閲覧数の増加に失敗しました",
      failedFetchNotice: "お知らせの取得に失敗しました",
      failedFetchBankingHistory: "金融取引履歴の取得に失敗しました",
      failedFetchTotalBankingHistory: "金融取引履歴の総数の取得に失敗しました",
      failedFetchDownlineBankingHistory: "下位ラインの金融取引履歴の取得に失敗しました",
      failedFetchDownlineTotalBankingHistory: "下位ラインの金融取引履歴の総数の取得に失敗しました",
      failedAddBankingHistory: "金融取引履歴の追加に失敗しました",
      failedUpdateBankingHistoryStatus: "銀行取引履歴のステータス更新に失敗しました",
      failedFetchChipTransactionHistory: "チップ取引履歴の取得に失敗しました",
      failedFetchTotalChipTransactionHistory: "チップ取引履歴の総数の取得に失敗しました",
      failedFetchDownlineChipTransactionHistory: "下位ラインのチップ取引履歴の取得に失敗しました",
      failedFetchDownlineTotalChipTransactionHistory: "下位ラインのチップ取引履歴の総数の取得に失敗しました",
      failedAddChipTransactionHistory: "チップ取引履歴の追加に失敗しました",
      failedFetchGameBetHistoryByCallbackId: "コールバックIDによるゲームベット履歴の取得に失敗しました",
      failedFetchGameBetHistory: "ゲームベット履歴の取得に失敗しました",
      failedFetchTotalGameBetHistory: "ゲームベット履歴の総数の取得に失敗しました",
      failedFetchDownlineGameBetHistory: "下位ラインのゲームベット履歴の取得に失敗しました",
      failedFetchDownlineTotalGameBetHistory: "下位ラインのゲームベット履歴の総数の取得に失敗しました",
      failedAddGameBetHistory: "ゲームベット履歴の追加に失敗しました",
      failedFetchChipChangeHistory: "チップ変更履歴の取得に失敗しました",
      failedFetchTotalChipChangeHistory: "チップ変更履歴の総数の取得に失敗しました",
      failedAddChipChangeHistory: "チップ変更履歴の追加に失敗しました",
      failedFetchGameCallbackHistory: "ゲームコールバック履歴の取得に失敗しました",
      failedFetchTotalGameCallbackHistory: "ゲームコールバック履歴の総数の取得に失敗しました",
      failedAddGameCallbackHistory: "ゲームコールバック履歴の追加に失敗しました",
      failedUpdateGameCallbackHistory: "ゲームコールバック履歴の更新に失敗しました",
      failedDeleteGameCallbackHistory: "ゲームコールバック履歴の削除に失敗しました",
      failedFetchGamePlayHistory: "ゲームプレイ履歴の取得に失敗しました",
      failedFetchTotalGamePlayHistory: "ゲームプレイ履歴の総数の取得に失敗しました",
      failedAddGamePlayHistory: "ゲームプレイ履歴の追加に失敗しました",
      failedFetchLoginHistory: "ログイン履歴の取得に失敗しました",
      failedFetchTotalLoginHistory: "ログイン履歴の総数の取得に失敗しました",
      failedAddLoginHistory: "ログイン履歴の追加に失敗しました",
      failedFetchPointChangeHistory: "ポイント変更履歴の取得に失敗しました",
      failedFetchTotalPointChangeHistory: "ポイント変更履歴の総数の取得に失敗しました",
      failedAddPointChangeHistory: "ポイント変更履歴の追加に失敗しました",
      failedFetchSettings: "設定リストの取得に失敗しました",
      failedFetchSettingByKey: "キーによる設定の取得に失敗しました",
      failedCreateSetting: "設定の作成に失敗しました",
      noFieldsToUpdateSetting: "更新するフィールドがありません",
      settingNotFound: "設定が見つかりません",
      failedUpdateSetting: "設定の更新に失敗しました",
      failedDeleteSetting: "設定の削除に失敗しました",
      failedUpdateMultipleSettings: "複数の設定の更新に失敗しました",
      failedFetchUserDownlineTotalFinance: "下位ラインの総財務情報の取得に失敗しました",
      failedFetchUserDownlineSettlement: "下位ラインの決済情報の取得に失敗しました",
      failedFetchMyTotalAddedChips: "合計追加チップ数の取得に失敗しました",
      failedFetchMyTotalSubtractedChips: "合計差し引きチップ数の取得に失敗しました",
      failedFetchMyMoneyChanges: "資金変動履歴の取得に失敗しました",
      failedFetchTodaysNewUsers: "本日の新規ユーザー数の取得に失敗しました",
      failedFetchTodayStats: "本日の統計の取得に失敗しました",
      failedFetchTotalPendingUsers: "合計承認待ちユーザー数の取得に失敗しました",
      failedFetchTotalOnlineUsers: "合計オンラインユーザー数の取得に失敗しました",
      failedFetchTotalPendingInquiries: "合計処理待ち問い合わせ数の取得に失敗しました",
      failedFetchTotalDepositAndWithdraw: "合計入出金情報の取得に失敗しました",
      failedFetchMonitoringStats: "モニタリング統計の取得に失敗しました",
      failedUpdateUserFinance: "ユーザー財務情報の更新に失敗しました",
      failedAddUserChip: "ユーザーチップの追加に失敗しました",
      failedAddUserPoint: "ユーザーポイントの追加に失敗しました",
      failedSubtractUserChip: "ユーザーチップの差し引きに失敗しました",
      failedCollectSubUserChips: "下位ユーザーチップの回収に失敗しました",
      failedGiveChipsToSubUser: "下位ユーザーへのチップ付与に失敗しました",
      failedUpdateUserStatus: "ユーザーのステータス更新に失敗しました",
      failedUpdateUserRole: "ユーザーの役割更新に失敗しました",
      failedUpdateUserOnlineStatus: "ユーザーのオンラインステータス更新に失敗しました",
      failedUpdateGameVendorForDownline: "下位ラインのゲームベンダー更新に失敗しました",
      failedCreateUsers: "複数ユーザーの作成に失敗しました",
      failedFetchUserById: "IDによるユーザー取得に失敗しました",
      failedFetchUserByVendorId: "ベンダーIDによるユーザー取得に失敗しました",
      failedFetchUserFinance: "ユーザー財務情報の取得に失敗しました",
      failedFetchUserRowsByRole: "役割別ユーザー行数の取得に失敗しました",
      failedFetchAdminId: "管理者IDの取得に失敗しました",
      failedFetchHeadquarterId: "本社IDの取得に失敗しました",
      failedFetchUsersByReferrer: "紹介者別ユーザーの取得に失敗しました",
      failedFetchUsersWithoutReferrer: "紹介者なしユーザーの取得に失敗しました",
      failedFetchPendingUsersTotal: "承認待ちユーザー総数の取得に失敗しました",
      failedFetchOnlineUsersTotal: "オンラインユーザーの合計取得に失敗しました",
      failedFetchUserDetail: "ユーザー詳細の取得に失敗しました",
      userNotFound: "ユーザーが見つかりません。",
      failedFetchVendorHistory: "ベンダー履歴の取得に失敗しました。",
      failedAddVendorHistory: "ベンダー履歴の追加に失敗しました。",
      failedUpdateVendorHistory: "ベンダー履歴の更新に失敗しました。",
      referrerNotFound: "紹介者が見つかりません",
      failedToGetAdminId: "管理者IDの取得に失敗しました",
      failedToGetHeadquarterId: "本部IDの取得に失敗しました",
      failedToGetUserDetail: "ユーザー詳細の取得に失敗しました",
      failedToGetUserFinance: "ユーザーの財務情報の取得に失敗しました",
      failedFetchUserByRole: "役割別ユーザーの取得に失敗しました",
      failedAddBetAmount: "ベット金額の追加に失敗しました",
      invalidReason: "理由が無効です",
      refreshTokenRequired: "リフレッシュトークンが必要です",
    },
    pagination: {
      previous: "前へ",
      next: "次へ",
      page: "ページ",
    },
    roles: {
      admin: "管理者",
      headquarter: "本社",
      headquarter_branch: "支社",
      branch: "支社",
      distributor: "代理店",
      store: "店舗",
      user: "ユーザー",
    },
    appBar: {
      search: {
        placeholder: "検索...",
      },
      userProfile: "プロフィール",
      userSettings: "設定",
      darkMode: "ダークモード",
      lightMode: "ライトモード",
      logout: "ログアウト",
    },
    loading: {
      loading: "読み込み中...",
      error: "エラーが発生しました: ",
    },
    search: {
      placeholder: "検索語を入力してください",
      button: "検索",
      datePlaceholder: "日付を選択",
    },
    userTree: {
      title: "組織図",
    },
    status: {
      approved: "承認",
      rejected: "拒否",
      pending: "承認待ち",
      canceled: "キャンセル",
    },
    gameVendorSelect: {
      officialLabel: "公式ゲームベンダー",
      unofficialLabel: "非公式ゲームベンダー",
      officialPlaceholder: "公式ゲームベンダーを選択",
      unofficialPlaceholder: "非公式ゲームベンダーを選択",
      save: "保存",
      none: "なし",
    },
    dateRangeSelector: {
      startDatePlaceholder: "開始日",
      endDatePlaceholder: "終了日",
      selectPlaceholder: "期間を選択",
      periods: {
        day: "今日",
        week: "1週間",
        twoWeeks: "2週間",
        month: "1ヶ月",
        threeMonths: "3ヶ月",
        sixMonths: "6ヶ月",
        year: "1年",
        custom: "カスタム",
      },
    },
  },
  auth: {
    login: "ログイン",
    register: "新規登録",
    loginDescription: "ユーザー名とパスワードを入力してログインしてください",
    registerDescription: "新しいアカウントを作成",
    email: "メールアドレス",
    password: "パスワード",
    username: "ユーザー名",
    referrer: "紹介者",
    referrerPlaceholder: "紹介者のユーザー名を入力してください",
    confirmPassword: "パスワード確認",
    loginButton: "ログイン",
    registerButton: "登録",
    captcha: "セキュリティ質問",
    captchaPlaceholder: "回答を入力してください",
    loginProcessing: "ログイン中...",
    registerProcessing: "処理中...",
    hasAccount: "すでにアカウントをお持ちですか？",
    noAccount: "アカウントをお持ちでないですか？",
    goToLogin: "ログインへ",
    goToRegister: "新規登録へ",
    minLengthUsername: "ユーザー名は3文字以上必要です",
    minLengthPassword: "パスワードは8文字以上必要です",
    invalidCaptcha: "セキュリティ回答が正しくありません",
    passwordMismatch: "パスワードが一致しません",
    loginSuccess: "ログイン成功",
    registerSuccess: "登録が完了しました",
    refresh: "更新",
  },
  sidebar: {
    systemManagement: "システム/お知らせ",
    partnerManagement: "パートナー管理",
    userManagement: "ユーザー管理",
    bankingManagement: "チャージ/換金管理",
    bettingStatus: "ベット/ローリング ステータス",
    apiDocs: "APIドキュメント",
    settings: "設定",
  },
  statsOverview: {
    balance: "保有金",
    pendingApproval: "承認待ち",
    depositRequest: "入金リクエスト",
    withdrawRequest: "出金リクエスト",
    inquiry: "1:1 問い合わせ",
    currentUsers: "現在のユーザー",
    cases: "件",
    users: "名",
    userBalance: "ユーザー チップ保有金",
    userPoint: "ユーザー ポイント保有金",
    partnerBalance: "パートナー チップ保有金",
    partnerPoint: "パートナー ポイント保有金",
  },
  dashboard: {
    title: "ダッシュボード",
    desc: "管理者ダッシュボード",
    registeredUsers: "登録ユーザー",
    activeUsers: "アクティブユーザー",
    systemStatus: "システム状態",
    systemNormal: "正常",
    allSystemsOperational: "全システム正常稼働中",
    topStats: {
      chip: {
        title: "チップ保有金",
        vendorBalance: "ベンダー チップ保有金",
      },
      point: {
        title: "保有ポイント",
        convertButton: "チップに変換",
      },
      user: {
        title: "ユーザー",
        listButton: "所属ユーザー一覧",
      },
    },
    moneyStatus: {
      userBalance: "ユーザー チップ保有金",
      userPoint: "ユーザー 保有ポイント",
      partnerBalance: "パートナー チップ保有金",
      partnerPoint: "パートナー 保有ポイント",
    },
    transactionSummary: {
      deposit: "チャージ",
      withdraw: "換金",
      chipGive: "チャージ付与",
      chipCollect: "チャージ回収",
      newUsers: "本日の新規ユーザー",
      profit: "本日のベッティング利益",
      profitDesc: "(ベット - 当選 - ローリング)",
    },
    transactionDetails: {
      title: "保有金 = チップ + ロール金, チャージ/換金は所属ユーザーへのチャージ/換金の合計",
      search: "検索",
      prevBalance: "前回保有金",
      deposit: "チャージ",
      withdraw: "換金",
      currentBalance: "現在保有金",
      bettingWinning: "ベット / 当選",
      rolling: "ロール金",
      userBalanceLabel: "ユーザー保有残高",
      partnerBalanceLabel: "パートナー保有残高",
      depositLabel: "チャージ",
      chipGiveLabel: "チャージ付与",
      totalLabel: "Total",
      withdrawLabel: "換金",
      chipCollectLabel: "チャージ回収",
      bettingLabel: "ベット金",
      winningLabel: "当選金",
      bettingResultLabel: "ベット - 当選",
      totalRollingLabel: "総ロール金",
      actualRollingLabel: "実ロール金",
    },
    transactionHistory: {
      title: "資金変動履歴",
      search: "検索",
      increase: {
        title: "保有金増加",
        headDeposit: "本社チャージ",
        upperChipGive: "上部チャージ付与",
        lowerChipCollect: "下部チャージ回収",
        rollingConvert: "ローリング金転換",
        total: "増加合計",
      },
      decrease: {
        title: "保有金減少",
        headWithdraw: "本社換金",
        upperChipCollect: "上部チャージ回収",
        lowerChipGive: "下部チャージ付与",
        total: "減少合計",
      },
    },
    notice: {
      title: "お知らせ",
      columns: {
        id: "#",
        title: "タイトル",
        createdAt: "作成日時",
      },
    },
  },
  users: {
    list: {
      title: "ユーザー一覧",
      desc: "登録ユーザーを管理します",
      columns: {
        username: "ユーザーID",
        details: "詳細",
        banking: "チャージ/換金",
        chip: "チャージ残高",
        point: "ポイント残高",
        affiliation: "所属",
        depositWithdraw: "入金/出金",
        slotStats: "(スロット)/ベット/当選/ローリング",
        casinoStats: "(カジノ)/ベット/当選/ローリング",
        sportsStats: "(スポーツ)/ベット/当選/ローリング",
      },
      filters: {
        byUsername: "ユーザーID順",
        byChip: "チップ残高順",
        byLatest: "新規登録順",
        byOldest: "古い順",
      },
    },
    pending: {
      title: "承認待ちユーザー",
      desc: "承認待ちユーザーを管理します",
      columns: {
        username: "ユーザーID",
        details: "詳細",
        status: "ステータス",
        headquarter: "本社",
        branch: "支社",
        distributor: "代理店",
        store: "店舗",
        createdAt: "作成日時",
        contact: "連絡先",
        actions: "承認",
      },
      approve: "承認",
      reject: "拒否",
      pendingStatus: "承認待ち",
      viewDetails: "詳細を見る",
    },
    online: {
      title: "オンラインユーザー",
      desc: "オンラインユーザーを管理します",
      columns: {
        username: "ユーザーID",
        details: "詳細",
        accountHolder: "口座名義",
        affiliation: "所属",
        banking: "チャージ/換金",
        chip: "チャージ残高",
        depositWithdraw: "総入金/総出金",
        slotStats: "(スロット)/ベット/当選/ローリング",
        casinoStats: "(カジノ)/ベット/当選/ローリング",
        sportsStats: "(スポーツ)/ベット/当選/ローリング",
        lastPlayedGame: "最近のゲーム",
      },
      noLastGame: "履歴なし",
    },
    chip: {
      giveTitle: "チャージ付与",
      collectTitle: "チャージ回収",
      giftTitle: "チャージ贈与",
      giveChip: "チャージ付与",
      collectChip: "チャージ回収",
      giftChip: "チャージ贈与",
      description: "金額と理由を入力し、確認ボタンをクリックしてください。",
      amount: "金額",
      memo: "メモ",
      memoPlaceholder: "メモを入力してください",
      errors: {
        invalidAmount: "有効な金額を入力してください",
        actionFailed: "処理に失敗しました",
      },
    },
    status: {
      active: "有効",
      pending: "保留中",
      rejected: "拒否",
      block: "ブロック",
      online: "オンライン",
      offline: "オフライン",
    },
    detail: {
      title: "ユーザー詳細",
      desc: "ユーザー詳細ページ",
      tabs: {
        userInfo: "会員情報",
        loginHistory: "ログイン履歴",
        messages: "メッセージ",
        chipChangeHistory: "チャージ履歴",
        rechargeHistory: "チャージ履歴",
        exchangeHistory: "換金履歴",
        chipReceivedHistory: "チャージ受取履歴",
        chipSentHistory: "チャージ送信履歴",
        gamePlayHistory: "ゲーム実行履歴",
        gameBetHistory: "ゲームベット履歴",
        restrictedGameBetting: "制限ゲームベット履歴",
        pragmatic: "プラグマティック",
        userLogs: "ユーザーログ履歴",
      },
      userSummary: {
        role: "形態",
        username: "ユーザー名",
        chip: "チップ",
        point: "ポイント",
      },
      userInfo: {
        title: "ユーザー詳細情報",
        basicInfo: "基本情報",
        moneyInfo: "財務情報",
        gameInfo: "ゲーム情報",
        bankInfo: "銀行情報",
        number: "番号",
        password: "パスワード",
        username: "ユーザー名",
        contact: "連絡先",
        status: "ステータス",
        gameVendor: "ゲームベンダー",
        gameVendorPlaceholder: "ゲームベンダーを選択",
        chip: "チップ",
        point: "ポイント",
        totalDeposit: "総入金",
        totalWithdraw: "総出金",
        slotBet: "スロットベット",
        slotWin: "スロット勝利",
        casinoBet: "カジノベット",
        casinoWin: "カジノ勝利",
        sportsBet: "スポーツベット",
        sportsWin: "スポーツ勝利",
        casinoBetLimit: "ライブカジノベット",
        casinoWinLimit: "ライブカジノ勝利",
        bankName: "銀行名",
        bankAccount: "口座番号",
        bankAccountHolder: "口座名義",
        memo: "メモ",
        memoPlaceholder: "メモを入力してください",
        createdAt: "登録日時",
        lastLogin: "最終ログイン",
        blockRejectReason: "ブロック・拒否理由",
        blockRejectReasonPlaceholder:
          "ブロックまたは拒否の理由を入力してください",
      },
      loginHistory: {
        title: "ログイン履歴",
        columns: {
          ipAddr: "接続IP",
          isSuccess: "成功可否",
          createdAt: "接続日時",
          actions: "操作",
          blockIP: "IPブロック",
        },
      },
      chipChangeHistory: {
        title: "チャージ履歴",
        columns: {
          amountBefore: "変動前",
          amountAfter: "変動後",
          amountDiff: "増減",
          sender: "送信者",
          receiver: "受信者",
          reason: "理由",
          referenceValue: "参照値",
          rollingBefore: "ローリング(前)",
          rollingAfter: "ローリング(後)",
          createdAt: "変動日時",
        },
      },
      rechargeHistory: {
        title: "チャージ履歴",
        columns: {
          amountBefore: "チャージ前",
          amountAfter: "チャージ後",
          requestAmount: "チャージ金額",
          bankInfo: "銀行情報",
          status: "状態",
          requestedAt: "チャージ日時",
          processedAt: "処理日時",
          memo: "メモ",
        },
      },
      exchangeHistory: {
        title: "換金履歴",
        columns: {
          amountBefore: "換金前",
          amountAfter: "換金後",
          requestAmount: "換金金額",
          bankInfo: "銀行情報",
          status: "状態",
          requestedAt: "換金日時",
          processedAt: "処理日時",
          memo: "メモ",
        },
      },
      chipReceiveHistory: {
        title: "チャージ受取履歴",
        columns: {
          receiverId: "受取者ID",
          receiverUsername: "受取者ユーザー名",
          receiverRole: "受取者区分",
          amount: "チャージ金額",
          reason: "理由",
          memo: "メモ",
          createdAt: "登録日時",
        },
      },
      chipSendHistory: {
        title: "チャージ送信履歴",
        columns: {
          senderId: "送信者ID",
          senderUsername: "送信者ユーザー名",
          senderRole: "送信者区分",
          amount: "チャージ金額",
          reason: "理由",
          memo: "メモ",
          createdAt: "登録日時",
        },
      },
      gamePlayHistory: {
        title: "ゲーム実行履歴",
        columns: {
          supplier: "ゲームプロバイダー",
          gameName: "ゲーム名",
          executionTime: "実行日時",
        },
      },
      gameBetHistory: {
        title: "ゲームベット履歴",
        columns: {
          supplier: "ゲームプロバイダー",
          gameName: "ゲーム名",
          roundId: "ラウンドID",
          type: "種類",
          betAmount: "ベット金額",
          winAmount: "勝利金額",
          balance: "残高",
          betTime: "ベット日時",
          details: "詳細",
        },
      },
    },
    creation: {
      title: "作成",
      desc: "新しい {0} を作成します",
      username: "ユーザー名",
      usernamePlaceholder: "ユーザー名を入力",
      password: "パスワード",
      passwordPlaceholder: "パスワードを入力",
      count: "数",
      countPlaceholder: "数を入力してください",
      errors: {
        requiredFields: "ユーザー名とパスワードを入力してください",
        invalidCount: "数は0以上である必要があります",
      },
      contact: "連絡先",
      contactPlaceholder: "連絡先を入力してください",
      bank: "銀行",
      bankSelect: "=== 選択 ===",
      bankKookmin: "国民",
      bankShinhan: "新韓",
      bankWoori: "ウリ",
      bankNonghyup: "農協",
      bankHana: "ハナ",
      accountNumber: "口座番号",
      accountNumberPlaceholder: "口座番号を入力してください",
      accountHolder: "口座名義",
      accountHolderPlaceholder: "口座名義を入力してください",
      rollingRateSlot: "ローリング手数料率(スロット)",
      losingRateSlot: "ルージング手数料率(スロット)",
      rollingRateCasino: "ローリング手数料率(カジノ)",
      losingRateCasino: "ルージング手数料率(カジノ)",
      rollingRateSports: "ローリング手数料率(スポーツ)",
      losingRateSports: "ルージング手数料率(スポーツ)",
    },
  },
  partners: {
    common: {
      add: "パートナー登録",
    },
    list: {
      all: {
        title: "パートナー一覧",
        desc: "登録パートナーを管理します",
      },
      head: {
        title: "本社一覧",
        desc: "登録本社を管理します",
      },
      headBranch: {
        title: "本社支社一覧",
        desc: "登録本社支社を管理します",
      },
      branch: {
        title: "支社一覧",
        desc: "登録支社を管理します",
      },
      distributor: {
        title: "代理店一覧",
        desc: "登録代理店を管理します",
      },
      store: {
        title: "店舗一覧",
        desc: "登録店舗を管理します",
      },
      search: {
        placeholder: "パートナー ユーザー名を入力",
      },
      columns: {
        username: "ユーザーID",
        details: "詳細",
        role: "形態",
        banking: "チャージ/換金",
        chip: "チャージ残高",
        point: "保有ポイント",
        depositWithdraw: "入出金",
        rollingPercentage: {
          slot: "ロール % (スロット)",
          casino: "ロール % (カジノ)",
          sports: "ロール % (スポーツ)",
        },
        losingPercentage: {
          slot: "ルージング % (スロット)",
          casino: "ルージング % (カジノ)",
          sports: "ルージング % (スポーツ)",
        },
        createdAt: "登録日時",
        hqTransactions: "本社入出金",
        chipTransactions: "チャージ付与/回収",
        betting: {
          casino: "ベット(カジノ)",
          slot: "ベット(スロット)",
          sports: "ベット(スポーツ)",
        },
        downlineManagement: "下部管理",
        createDownline: "下部登録",
      },
      statsCard: {
        basicInfo: {
          title: "基本情報",
          type: "区分",
          username: "ユーザー名",
          chipAndPointBalance: "チップ / ポイント",
          contact: "連絡先",
          bankName: "銀行名",
          bankAccount: "口座番号",
          accountHolder: "口座名義",
        },
        rollingAndLosing: {
          title: "ロール & ルージング",
          convertButton: "保有金に転換",
          rollingPercentage: {
            slot: "ロール % (スロット)",
            casino: "ロール % (カジノ)",
            sports: "ロール % (スポーツ)",
          },
          losingPercentage: {
            slot: "ルージング % (スロット)",
            casino: "ルージング % (カジノ)",
            sports: "ルージング % (スポーツ)",
          },
        },
        bettingAndRolling: {
          title: "ベット 及び ロール金",
          bettingWinning: {
            title: "ベット/当選",
            slot: "ベット/当選 (スロット)",
            casino: "ベット/当選 (カジノ)",
            sports: "ベット/当選 (スポーツ)",
          },
          rolling: {
            slot: "ロール金 (スロット)",
            casino: "ロール金 (カジノ)",
            sports: "ロール金 (スポーツ)",
          },
        },
        moneyMovement: {
          title: "資金移動",
          totalDeposit: "入金合計",
          totalWithdraw: "出金合計",
          totalChipGive: "チャージ付与合計",
          totalChipCollect: "チャージ回収合計",
        },
      },
    },
    chipTransfer: {
      title: "パートナー アル移動",
      desc: "パートナー間のアル移動を管理します",
      columns: {
        fromUser: "送金元",
        fromRole: "送金元区分",
        toUser: "送金先",
        toRole: "送金先区分",
        amount: "金額",
        memo: "メモ",
        createdAt: "移動時間",
      },
    },
    partnerUserChipTransfer: {
      title: "パートナー ↔ ユーザー チャージ移動",
      desc: "パートナーとユーザー間のチャージ移動を管理します",
      search: {
        placeholder: "パートナーまたはユーザー名を入力",
      },
      columns: {
        partnerUsername: "パートナー名",
        partnerRole: "パートナー区分",
        username: "ユーザー名",
        giveAmount: "付与金額",
        collectAmount: "回収金額",
        createdAt: "日時",
      },
    },
  },
  banking: {
    rechargeHistory: {
      title: "チャージ履歴",
      desc: "チャージ履歴ページ",
      columns: {
        id: "#",
        type: "区分",
        amount: "チャージ金額",
        countAndTotal: "チャージ件数 / 合計",
        balanceChange: "チャージ前 / チャージ後",
        username: "ユーザー名",
        affiliation: "所属",
        bankName: "銀行名",
        accountHolder: "口座名義",
        dates: "申請日時 / 処理日時",
        status: "状態",
        details: "詳細",
        memo: "メモ",
        deposit: "チャージ",
        withdraw: "換金",
      },
    },
    exchangeHistory: {
      title: "チャージ履歴",
      desc: "チャージ履歴ページ",
      columns: {
        id: "#",
        type: "区分",
        amount: "チャージ金額",
        countAndTotal: "チャージ件数 / 合計",
        balanceChange: "チャージ前 / チャージ後",
        username: "ユーザー名",
        affiliation: "所属",
        bankName: "銀行名",
        accountHolder: "口座名義",
        dates: "申請日時 / 処理日時",
        status: "状態",
        details: "詳細",
        memo: "メモ",
        deposit: "チャージ",
        withdraw: "換金",
      },
    },
  },
  notices: {
    list: {
      title: "お知らせ管理",
      desc: "お知らせ管理ページ",
      createButton: "お知らせ作成",
      columns: {
        title: "タイトル",
        status: "状態",
        viewCount: "閲覧数",
        createdAt: "作成日",
        updatedAt: "更新日",
        actions: "管理",
        pinButton: "固定",
        unpinButton: "固定解除",
        viewButton: "表示",
        editButton: "編集",
        deleteButton: "削除",
      },
    },
    detail: {
      title: "お知らせ詳細",
      desc: "お知らせ詳細ページ",
      notFound: "お知らせが見つかりません。",
    },
    edit: {
      title: "お知らせ編集",
      desc: "お知らせ編集ページ",
      titleLabel: "タイトル",
      contentLabel: "内容",
      statusLabel: "状態",
      pinnedLabel: "トップに固定",
    },
    delete: {
      title: "お知らせ削除",
      desc: "このお知らせを削除してもよろしいですか？",
    },
    status: {
      all: "すべて",
      draft: "下書き",
      published: "公開中",
      deleted: "削除済み",
    },
  },
  inquiry: {
    types: {
      deposit: "チャージ お問い合わせ",
      withdrawal: "換金 お問い合わせ",
      account: "チャージ 口座 お問い合わせ",
      other: "その他 お問い合わせ",
    },
  },
  inquiries: {
    list: {
      title: "1:1 お問い合わせ",
      desc: "お問い合わせリストページ",
      columns: {
        title: "タイトル",
        status: "状態",
        creator: "作成者",
        createdAt: "作成日",
        answerer: "回答者",
        answeredAt: "回答日",
      },
      search: {
        placeholder: "タイトルまたは内容で検索",
      },
      noData: "お問い合わせ履歴がありません。",
    },
    detail: {
      title: "お問い合わせ詳細",
      desc: "お問い合わせ詳細ページ",
      notFound: "お問い合わせが見つかりません。",
    },
    status: {
      all: "すべて",
      pending: "待機中",
      inProgress: "処理中",
      completed: "完了",
      deleted: "削除済み",
    },
    answer: {
      title: "回答",
      status: "処理状態",
      content: "回答内容",
      placeholder: "回答を入力してください",
      submit: "回答を登録",
      success: "回答が登録されました。",
      error: "回答の登録に失敗しました。",
      required: "回答内容を入力してください。",
    },
  },
  bettingStatus: {
    common: {
      rollingDesc: "※ ローリング = ベッティング x ローリング%, ※ 実支給 = ローリング - 下線ローリング",
      losingDesc: "※ ロス = (ベッティング - 当選 - 総ローリング) x ローリング%, ※ 実支給 = ロス - 下線ロス",
      selectedPartner: "選択されたパートナーのベッティング & ローリングデータ",
      downlinePartners: "下線パートナーのベッティング & ローリングデータ",
    },
    slot: {
      title: "ベッティング状況（スロット）",
      desc: "Slot betting status page",
    },
    casino: {
      title: "ベッティング状況（カジノ）",
      desc: "Casino betting status page",
    },
    sports: {
      title: "ベッティング状況（スポーツ）",
      desc: "Sports betting status page",
    },
    slotHistory: {
      title: "ベッティング 履歴（スロット）",
      desc: "スロット ベッティング 履歴 ページ",
    },
    casinoHistory: {
      title: "ベッティング 履歴（カジノ）",
      desc: "カジノ ベッティング 履歴 ページ",
    },
    sportsHistory: {
      title: "ベッティング 履歴（スポーツ）",
      desc: "スポーツ ベッティング 履歴 ページ",
    },
    losingSettlement: {
      slot: {
        title: "ロス 清算（スロット）",
        desc: "スロット ロス 清算 ページ",
      },
      casino: {
        title: "ロス 清算（カジノ）",
        desc: "カジノ ロス 清算 ページ",
      },
      sports: {
        title: "ロス 清算（スポーツ）",
        desc: "スポーツ ロス 清算 ページ",
      },
      columns: {
        role: "区分",
        partnerName: "パートナー名",
        totalPartnerDeposit: "パートナー総チャージ",
        totalPartnerWithdraw: "パートナー総換金",
        totalBetting: "総ベッティング",
        totalWinning: "総当選金",
        bettingResult: "ベッティング - 当選",
        rollingPercentage: "ローリング%",
        totalRolling: "総ローリング",
        actualRolling: "実支給ローリング",
        losingPercentage: "ロス%",
        losingAmount: "ロス金",
        settlementAmount: "清算金",
        downlineSettlementAmount: "下線清算金",
        actualPaymentAmount: "実支給金",
      },
    },
    lossAdjustment: {
      title: "ロス調整",
      desc: "Loss adjustment page",
      columns: {
        headquarter: "本社",
        branch: "支社",
        storeUsername: "店舗 ユーザー名",
        yesterdayBetting: "昨日 ベッティング",
        yesterdayWin: "昨日 当選",
        yesterdayRolling: "昨日 ローリング",
        subtract: "マイナス",
        loss: "ロス",
        add: "プラス",
      },
      buttons: {
        setAll0: "全体を0に",
        setAll5: "全体を5に",
        setAll10: "全体を10に",
        setAll15: "全体を15に",
        setAll20: "全体を20に",
      },
    },
    lossRecovery: {
      title: "ロス回復",
      desc: "ロス回復ページ",
      columns: {
        storeName: "店舗名",
        username: "ユーザー名",
        gameName: "ゲーム名",
        date: "日付",
        bettingAmount: "ベット金額",
        winningAmount: "当選金額",
        rollingAmount: "ローリング金額",
        storeRecoveryStatus: "店舗別回復状態",
        userRecoveryStatus: "ユーザー別回復状態",
        status: "状態",
      },
    },
    bettingStatusColumns: {
      role: "区分",
      partnerName: "パートナー名",
      totalPartnerDeposit: "パートナー総チャージ",
      totalPartnerWithdraw: "パートナー総換金",
      totalBetting: "総ベッティング",
      totalWinning: "総当選金",
      bettingResult: "ベッティング - 当選",
      rollingPercentage: "ローリング%",
      totalRolling: "総ローリング",
      actualRolling: "実支給ローリング",
      bettingProfit: "ベッティング損益",
      currentChip: "保有アル",
      currentRolling: "保有ローリング",
    },
  },
  swagger: {
    title: "APIドキュメント",
    description: "Piggy Vault 管理者APIドキュメント。",
  },
  settings: {
    title: "設定",
    description: "システム設定を管理する",
    tabs: {
      general: "一般",
      currency: "通貨",
      exchange: "為替レート",
      game: "ゲーム",
      etc: "その他",
    },
    groups: {
      general: {
        title: "一般設定",
        description: "一般的なシステム設定を構成します。",
      },
      currency: {
        title: "通貨設定", 
        description: "通貨表示と標準設定を管理します。",
      },
      exchange: {
        title: "為替レート設定",
        description: "USDT為替レート関連の設定を管理します。",
      },
      game: {
        title: "ゲーム設定",
        description: "ベンダーを含むゲーム関連の設定を構成します。",
      },
      etc: {
        title: "その他の設定",
        description: "その他の設定を管理します。",
      },
    },
    fields: {
      site_name: {
        label: "サイト名",
        description: "ウェブサイトの名前。",
      },
      maintenance: {
        label: "メンテナンスモード",
        description: "サイトのメンテナンスモードを有効または無効にします。(on/off)",
      },
      std_currency: {
        label: "標準通貨",
        description: "計算に使用される標準通貨。",
      },
      dsp_currency: {
        label: "表示通貨",
        description: "ユーザーに表示される通貨。",
      },
      usdt_exchange_rate: {
        label: "USDT為替レート設定",
        description: "USDT為替レートJSONデータのエディター。",
      },
      std_game_vendor_id: {
        label: "標準ゲームベンダー",
        description: "デフォルトのゲームベンダーID。",
      },
      // 他のフィールドの翻訳をここに追加できます。
    },
    messages: {
      settingKeyNotFound: "設定キー'$key'のインデックスが見つかりませんでした",
      loadingSettings: "設定を読み込み中...",
      errorLoadingSettings: "設定の読み込みエラー",
    },
    save_success: "設定が正常に保存されました！",
  },
  usdtExchangeRateEditor: {
    rawJsonEditorTitle: "生のJSONエディター",
    exchangeRateAndWalletSettingsTitle: "為替レートとウォレット設定",
    usdtExchangeRateLabel: "USDT為替レート (ex_rate)",
    myWalletUrlLabel: "マイウォレットURL (my_wallet)",
    quickAmountsSettingsTitle: "クイック金額設定:",
    quickAmounts: {
      hide: "(非表示)",
      show: "(表示)",
      amountPlaceholder: "金額",
      labelPlaceholder: "ラベル (例: ¥1000)",
      addAmountButton: "クイック金額を追加",
    },
    addLanguagePrompt: "追加する言語コードを入力してください (例: th):",
    languageExistsError: "言語設定は既に存在します。",
    addNewLanguageQuickAmountButton: "新しい言語のクイック金額を追加",
    wallets: {
      title: "出金ウォレット一覧 (wallets)",
      walletNumberLabel: "ウォレット",
      namePlaceholder: "ウォレット名 (例: Polygon Tether)",
      addressPlaceholder: "ウォレットアドレス",
      qrPlaceholder: "QRコード画像パス (例: /uploads/polygon-img.jpeg)",
      deleteWalletButton: "このウォレットを削除",
      addWalletButton: "出金ウォレットを追加",
    },
    errors: {
      invalidJsonParse: "無効なJSON形式です",
      failedStringifyJson: "JSONの文字列変換に失敗しました (onChange)",
      invalidJsonFormatOrUseUI:
        "無効なJSON形式です。直接編集するか、下のUIを使用してください。",
    },
    rawJsonEditor: {
      editJsonDirectlyLabel: "JSONを直接編集",
      warningMessage:
        "警告: JSON形式が正しくない場合、設定が正しく保存されない可能性があります。",
    },
    loadingEditor: "エディターを読み込み中...",
  },
};

export default data;
